var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookIssued(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1538_2013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1538_2013",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0001297H44.9999V45H0V0.0001297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1538_2013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 4.2632V0.658821C21.4088 5.18517 22.4996 14.6201 22.4996 14.6201C22.4996 14.6201 23.5904 5.18517 35.179 0.658821V4.26329",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8443 5.67578C8.87807 3.58522 5.45658 2.80115 5.45658 2.80115L3.04883 5.24784",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6392 14.6201C21.0615 11.8011 18.7972 9.59103 16.4277 7.88411",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3594 14.6201C27.4194 5.57901 39.5425 2.8008 39.5425 2.8008L41.9503 5.24749",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58 44.3408H20.4199C19.9345 44.3408 19.541 43.9472 19.541 43.4619V15.4995C19.541 15.0141 19.9345 14.6206 20.4199 14.6206H24.58C25.0655 14.6206 25.4589 15.0141 25.4589 15.4995V43.4619C25.4589 43.9472 25.0655 44.3408 24.58 44.3408Z",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4589 20.6166H19.541V17.6869H25.4589V20.6166ZM25.4589 41.2754H19.541V38.3457H25.4589V41.2754Z",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.5254V33.4355",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2089 29.744V33.2796C44.2089 33.4355 44.1674 33.5886 44.0887 33.7232C44.0099 33.8578 43.8968 33.9691 43.7609 34.0455L26.7687 43.6036C26.1828 43.9332 25.459 43.5098 25.459 42.8376V15.1342C25.459 14.9782 25.5005 14.8251 25.5792 14.6905C25.6579 14.5559 25.771 14.4446 25.907 14.3682L42.8991 4.81012C43.485 4.48062 44.2089 4.9039 44.2089 5.57608V25.5253",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2312 43.6036L1.23908 34.0455C1.10315 33.9691 0.99 33.8578 0.911259 33.7232C0.832518 33.5886 0.791017 33.4354 0.791016 33.2795V5.57608C0.791016 4.9039 1.51497 4.48053 2.10085 4.81003L19.093 14.3681C19.2289 14.4446 19.342 14.5558 19.4208 14.6904C19.4995 14.8251 19.541 14.9782 19.541 15.1342V42.8376C19.541 43.5098 18.8171 43.9332 18.2312 43.6036Z",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9867 16.333L28.6816 23.3643V19.1147L40.9867 12.0834V16.333Z",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1538_2013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIssued);
export default __webpack_public_path__ + "static/media/book_issued.e52a1146f90dea41825d287f62dbb303.svg";
export { ForwardRef as ReactComponent };